import { fetchV3 } from "./client";

export const listSpecialities = () =>
  fetchV3({
    url: "doctors/specialties/",
    isSkippedRedirect403: true,
  });

export const listRelations = ({ useLoading = true } = {}) =>
  fetchV3({
    url: "patients/relations/",
    useLoading,
  });

export const listVisitTypes = () => fetchV3({ url: "visits/visit_types/" });

export const listDoctors = (filters = {}, { limit = 30 } = {}) =>
  fetchV3({
    url: "admin/doctors/",
    body: {
      search: filters.search,
      validation_statuses: filters.status?.join(","),
      regions: filters.region?.join(","),
      specialty: filters.specialty?.join(","),
      offset: filters.offset,
      limit,
    },
  });

export const inviteDoctor = (doctorUuid) =>
  fetchV3({ url: `admin/doctors/${doctorUuid}/?invite=true` });

export const listShifts = (filters) =>
  fetchV3({
    url: "shifts/",
    body: filters,
    useLoading: true,
  });

export const listNotifications = () =>
  fetchV3({
    url: "notifications/",
    useLoading: false,
  });

export const markAllNotificationsRead = () =>
  fetchV3({
    method: "PATCH",
    url: "notifications/mark-all-as-read/",
    useLoading: false,
  });
